import {useCallback} from "react"
import {useModel} from "./useModel"
import moment from "moment"
import {formatDateOnly, toDateOnlyString} from "helpers"

type DateValue = string | Date
const useDateTimeFormatters = () => {
    const model = useModel()
    const userTimeFormat = model.getUserTimeFormat()
    const userDateFormat = model.getUserDateFormat()
    const userDateTimeFormat = model.getUserDateTimeFormat()
    const formatTime = useCallback(
        (datetime: DateValue) => {
            return moment(datetime).format(userTimeFormat)
        },
        [userTimeFormat]
    )
    const formatDate = useCallback(
        (datetime: DateValue) => {
            return formatDateOnly(datetime, userDateFormat)
        },
        [userDateFormat]
    )
    const formatDateTime = useCallback(
        (datetime: DateValue) => {
            return moment(datetime).format(userDateTimeFormat)
        },
        [userDateTimeFormat]
    )
    return {
        userDateFormat,
        userDateTimeFormat,
        userTimeFormat,
        formatDateTime,
        formatTime,
        formatDate,
        toDateOnlyString
    }
}

export {useDateTimeFormatters}
